'use strict';

module.exports = function (element, duration = 500) {
    var position = element && element.length ? element.offset().top : 0;
    $('html, body').animate({
        scrollTop: position
    }, duration);
    if (!element) {
        $('.logo-home').focus();
    }
};
